import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => ({
  works: [],
  loading: false,
  filters: [],
  activeFilters: {},
  page: 1
});

const removeFilter = (opts, key) => {
  const { [key]: _, ...rest } = opts;
  return rest;
};

const worksReducer = createReducer(getDefaultState(), {
  [Constants.works.load]: (state) => ({
    ...state,
    loading: true
  }),
  [Constants.works.success]: (state, { works }) => ({
    ...state,
    works: [...state.works, ...(works || [])],
    loading: false,
    page: state.page + 1
  }),
  [Constants.works.filtersLoaded]: (state, { filters }) => ({
    ...state,
    filters
  }),
  [Constants.works.addFilter]: (state, { param, value, text }) => ({
    ...state,
    page: 1,
    activeFilters: {
      ...state.activeFilters,
      [param]: { value, text }
    },
    works: []
  }),
  [Constants.works.removeFilter]: (state, { param }) => ({
    ...state,
    page: 1,
    activeFilters: removeFilter(state.activeFilters, param),
    works: []
  })
});

export default worksReducer;
